import { dateMask, currencyMask } from '../../../../../utils/helpers/masking'

interface InvoiceDetailsRow {
  label: string
  value: string
  isRed?: boolean
}

export const getInvoiceDetailsRows = (
  t: (key: string) => string,
  invoice: { invoice_due_date: string },
  invoiceAmount: number,
  lateFee?: number,
): InvoiceDetailsRow[] => {
  const rows: InvoiceDetailsRow[] = [
    {
      label: t('global:payIhcInvoice.invoiceData.dueDate'),
      value: dateMask(invoice.invoice_due_date),
      isRed: !!lateFee,
    },
    {
      label: t('global:payIhcInvoice.invoiceData.outstandingAmount'),
      value: currencyMask(invoiceAmount),
    },
  ]

  if (lateFee) {
    rows.push({
      label: t('global:payIhcInvoice.invoiceData.lateInterestCharge'),
      value: currencyMask(lateFee),
      isRed: true,
    })
  }

  return rows
}

export const formatPaymentMethodName = (paymentMethod: any): string => {
  if (!paymentMethod) return ''

  const name = (paymentMethod.accountName || paymentMethod.name).split('/')[0]
  const lastFourDigits = paymentMethod.accountNumber?.slice(-4) || ''

  if (paymentMethod.paymentMethodType === 'card') {
    const cardType = paymentMethod.cardMetadata?.type || ''
    const cleanName = name
      .replace(/-/g, ' ')
      .replace(/\s+card\s*/gi, ' ')
      .trim()
    return `${cleanName} ${cardType} Card ${lastFourDigits}`
  }

  return `${name} ${lastFourDigits}`
}
